import { render, staticRenderFns } from "./FamilyDetails.vue?vue&type=template&id=4e7f9642"
import script from "./FamilyDetails.vue?vue&type=script&lang=js"
export * from "./FamilyDetails.vue?vue&type=script&lang=js"
import style0 from "./FamilyDetails.vue?vue&type=style&index=0&id=4e7f9642&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports